module.exports = __webpack_public_path__ + "img/img-web-subsidio-maternidad.45fe110e.jpg";